module.exports = __webpack_public_path__ + "img/taxi-colored.0694c16b.svg";